import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Tabs, Tab, Row, Col, Accordion, Card, Form, Button } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { AVA_DASHBOARD_TAB_KEY, STATE_STATUS, AVA_DASHBOARD_DOUGHNUT_TYPES } from '@awp/constants';
import AwpSearchBar from '@components/Common/AwpSearchBar';
import AwpSpinner from '@components/Common/AwpSpinner';
import DetailQualityView from '@awp/components/AvalancheMonitor/GraphView/DetailQualityView';
import LegendTable from '@awp/components/AvalancheMonitor/GraphView/LegendTable';
import { currentDashboardViews } from '@stores/avalancheDashboardViewPageSlice';
import { isValueEmpty, isValueNotEmpty } from '@awp/helpers/utilsReact';
const sotOutline = {
  outline: '0.063rem solid black',
  padding: '0rem 1rem',
  outlineOffset: '-0.063rem',
};
const AvalancheDetailContainer = () => {
  const [tabKey, setTabKey] = useState(AVA_DASHBOARD_TAB_KEY.QUALITY);
  const [search, setSearch] = useState('');
  const [searchBy, setSearchBy] = useState('');
  const [show, setShow] = useState(false);
  const [showCompleteness, setShowCompleteness] = useState(false);
  const [showTimeline, setShowTimeline] = useState(false);
  const [areas, setAreas] = useState([]);
  const dispatch = useDispatch();
  const dashboardViews = useSelector(currentDashboardViews);
  const dashboardViewPageStatus = useSelector((state) => state.avalancheDashboardViewPage.status);

  useEffect(() => {
    if (!dashboardViews) return;
    let _dashboardViews = { ...dashboardViews };
    console.log(_dashboardViews);
    let _qualityDetails = _dashboardViews.QualityDashboardViews;
    if (!_qualityDetails) return;
    let _grpDetails = _.groupBy(_qualityDetails, (ws) =>
      JSON.stringify({
        ProgramId: ws.ProgramId,
        AreaId: ws.AreaId,
        AreaLabel: ws.AreaLabel,
      }),
    );
    console.log(_grpDetails);
    let wxs = []; //ws= area
    Object.keys(_grpDetails).map((index) => {
      let grpWx = _grpDetails[index];
      let newWx = JSON.parse(index);
      let validGreen = 0;
      let invalidRed = 0;
      newWx.QualityColors = [0, 0];
      let filterGrpWx = [];
      Object.keys(grpWx).map((gw) => {
        if (!isValueEmpty(grpWx[gw].AreaId)) filterGrpWx.push(grpWx[gw]);
      });
      if (filterGrpWx && filterGrpWx.length > 0) {
        let validWx = filterGrpWx;
        Object.keys(validWx).map((key) => {
          // if (validWx[key]) {
          // 	invalidRed = invalidRed + validWx[key].InvalidObservationCount;
          // 	validGreen = validGreen + validWx[key].ObsCount - validWx[key].InvalidObservationCount;
          // 	// lateYellow = lateYellow + validWx[key].TimelineLateCount;
          // 	// ontimeGreen = ontimeGreen + validWx[key].ObsCount - validWx[key].TimelineLateCount;
          // 	// green = green + validWx[key].GreenCount;
          // 	// purple = purple + validWx[key].PurpleCount;
          // 	// red = red + validWx[key].RedCount;
          // 	// grey = grey + validWx[key].GreyCount;
          // }
          if (validWx[key] && validWx[key].Status === 'IngestFailed') {
            invalidRed++;
          } else if (validWx[key] && validWx[key].Status === 'Ingested') {
            validGreen++;
          }
          // if(validWx[key] && validWx[key].TimelineLateCount > 0){
          // 	lateYellow++;
          // }else{
          // 	ontimeGreen++;
          // }
        });
        newWx.QualityColors = [validGreen, invalidRed];
      }
      wxs.push(newWx);
    });
    let filterWxs = wxs;
    //@@@@@TO DO
    console.log(searchBy);
    if (!isValueEmpty(searchBy)) {
      filterWxs = wxs.filter((item) => {
        console.log(item);
        return (item.AreaLabel + '').toLowerCase().includes(searchBy.toLowerCase());
      });
    }
    console.log(filterWxs);
    setAreas(filterWxs);
  }, [dashboardViews, searchBy]);

  const clickOnSearch = () => {
    setSearchBy(search);
  };
  const enableShow = () => {
    setShow(!show);
  };
  const changeOnSearch = (e) => {
    if (e && e.target) {
      setSearch(e.target.value);
      setSearchBy(e.target.value);
    }
  };
  const changeOnRemove = () => {
    setSearch('');
    setSearchBy('');
  };
  return (
    <Card border="light" className="page-card">
      <Card.Header style={{ backgroundColor: 'transparent' }}>
        <Row>
          <Col lg={8}>
            <Tabs
              id="graph-tabs"
              activeKey={tabKey}
              onSelect={(k) => setTabKey(k)}
              className="mb-3 tab"
              transition={false}
            >
              {/* <Tab eventKey={DASHBOARD_TAB_KEY.TIMELINESS} title={DASHBOARD_DOUGHNUT_TYPES.TIMELINESS}></Tab>
						<Tab eventKey={DASHBOARD_TAB_KEY.COMPLETENESS} title={DASHBOARD_DOUGHNUT_TYPES.COMPLETENESS}></Tab> */}
              <Tab eventKey={AVA_DASHBOARD_TAB_KEY.QUALITY} title={'INGESTION SUCCESS RATE'}></Tab>
            </Tabs>
          </Col>
          <Col lg={4}>
            <AwpSearchBar value={search} onClick={clickOnSearch} onChange={changeOnSearch} onRemove={changeOnRemove} />
          </Col>
        </Row>
      </Card.Header>
      <Card.Body>
        {dashboardViewPageStatus == STATE_STATUS.LOADING && <AwpSpinner />}
        {dashboardViewPageStatus == STATE_STATUS.SUCCESS && (
          <>
            {/* <Row lg={12}>
						<Col lg={12}>{"Legend"}<Button variant="link" style={{ fontSize: "75%" }}
							onClick={enableShow} >{show ? "hide" : "show"}</Button></Col>
					</Row>
					{show && <Row lg={12}>
						<Col lg={11}><LegendTable tabKey={tabKey} /></Col><Col lg={1}></Col>
					</Row>} */}
            <Row lg={12} style={{ height: '1rem' }}></Row>
          </>
        )}

        {AVA_DASHBOARD_TAB_KEY.QUALITY === tabKey &&
          areas &&
          areas.length > 0 &&
          dashboardViewPageStatus == STATE_STATUS.SUCCESS && (
            <>
              {areas
                // .reduce(
                // 	function (accumulator, currentValue, currentIndex, array) {
                // 		if (currentIndex % 2 === 0)
                // 			accumulator.push(array.slice(currentIndex, currentIndex + 2));
                // 		return accumulator;
                // 	}, [])
                .map((ws, i) => {
                  return (
                    <Row key={i}>
                      <Col lg={12}>{ws && <DetailQualityView key={ws.AreaId} id={ws.AreaId} area={ws} />}</Col>
                      {/* <Col lg={6}>{ws[1] && <DetailQualityView key={ws[1].AreaId} id={ws[1].AreaId} area={ws[1]} />}</Col> */}
                    </Row>
                  );
                })}
            </>
          )}
      </Card.Body>
    </Card>
  );
};

export default AvalancheDetailContainer;
